import { type ApiErrorResponseDetails } from '../../api-schema-types/ApiResponseDetails'

 
export class RtkQueryHelper {
  static mapResponseError = (error?: any): string => {
    if (Boolean(error?.data) && ((error.data as ApiErrorResponseDetails).clientMessage) !== '') {
      return (error.data as ApiErrorResponseDetails)?.clientMessage
    }
    return JSON.stringify(error)
  }
}
